export const theme: ITheme = {
  white: '#FFFFFF',
  black: '#12152A',
  darkBlack: '#000000',
  grey: '#bbbbbb',
  textColorLabelAndP: '#6F7C98',
  sfPro: 'SFPro',
  roboto: 'Roboto',
  darkGrey: '#0A0F0A',
  green: '#3B5D3E',
  lightGreen: '#84C689',
  green2: '#548057',
  grey2: '#676767',
  hoverLightGreen: '#CEE8D0',
  darkGreen: '#0B170C',
  colorPrimary: '#0071CE',
  lightGrey: '#F4F4F5',
  textGrey: '#555758',
  helveticaNeue: 'Helvetica Neue',
  helveticaNeueBold: 'Helvetica Neue Bold',
  helveticaNeueMedium: 'Helvetica Neue Medium',
  caslonDoric: 'Caslon Doric Trial',
};

export interface ITheme {
  helveticaNeueBold: string,
  helveticaNeueMedium: string,
  grey2: string,
  green2: string,
  hoverLightGreen: string,
  lightGreen: string,
  darkGreen: string,
  green: string,
  textGrey: string,
  darkBlack: string,
  lightGrey: string,
  white: string,
  roboto: string,
  black: string,
  grey: string,
  sfPro: string,
  textColorLabelAndP: string,
  darkGrey: string,
  colorPrimary: string,
  helveticaNeue: string,
  caslonDoric: string,
}
